/* unplugin-vue-components disabled */import script from "./CourseDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseDemo.vue?vue&type=script&setup=true&lang=js"

import "./CourseDemo.vue?vue&type=style&index=0&id=55e3b2a8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55e3b2a8"]])

export default __exports__